function r({search:e,url:t}){return JSON.stringify({"@context":"http://schema.org","@type":"WebSite",url:t??null,potentialAction:[{"@type":"SearchAction",target:`${e}?q={search_term_string}`,"query-input":"required name=search_term_string"}]})}export{r as default};
//# sourceMappingURL=serialize-json-ld.js.map
